import React, { FC } from 'react'

import { IconTickSmallProps } from './IconTickSmall.types'
import * as Styled from './styles/IconTickSmall.style'

import { nonThemeableRules } from '../../ruleSet'

const IconTickSmall: FC<IconTickSmallProps> = ({
  size = nonThemeableRules.defaultSize as number as IconTickSmallProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconTickSmallProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 122' xmlns='http://www.w3.org/2000/svg'>
        <path d='M57.3 109.5c-2.7 0-5.3-1-7.4-3.1L19 75.6c-4-4.1-4-10.7 0-14.7 4.1-4.1 10.7-4.1 14.7 0l23.5 23.5 68.9-68.9c4.1-4.1 10.7-4.1 14.7 0 4.1 4.1 4.1 10.7 0 14.7l-76.3 76.3c-1.8 2-4.5 3-7.2 3' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconTickSmall
